import { render, staticRenderFns } from "./OrgManager.vue?vue&type=template&id=a306c456&scoped=true&"
import script from "./OrgManager.vue?vue&type=script&lang=js&"
export * from "./OrgManager.vue?vue&type=script&lang=js&"
import style0 from "./OrgManager.vue?vue&type=style&index=0&id=a306c456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a306c456",
  null
  
)

export default component.exports